import React, { Component,useEffect,useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable,{defaultThemes} from 'react-data-table-component';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HTMLParserComponent from "../../HTMLParserComponent.js"

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import '../../preloading.css';

import Pagination from '../../Pagination/Paginations.js';
import EntriesSelector from '../../Pagination/EntriesSelector';
import useSortData from "../../Pagination/SortData";





import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const MyshiftControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;

	// function getDate() {
	// 	const today = new Date();
	// 	const month = today.getMonth() + 1;
	// 	const year = today.getFullYear();
	// 	const date = today.getDate();
	// 	return `${year}-${month}-${date}`;
	//   }

	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        start_date: today,
        end_date: today,
        shift_id:"ALL",
    })



	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [summary, setSummary] = useState(null);
	const [loading, setLoading] = useState(false);

	const { sortConfig, sortData, handleSort } = useSortData();
	const cleanHTML = (str) => str.replace(/<[^>]+>/g, ''); // remove HTML tags


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

        if (event.target.value === '1') {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
    }


		const [searchTerm, setSearchTerm] = useState("");
			const [currentPage, setCurrentPage] = useState(1);
			const [entriesPerPage,setEntriesPerPage]=useState(10);
		// punch_in / punch_out arrive as HTML -- either a time, a "Missed Punch"
		// badge, or empty when the day has no attendance row at all
		const hasPunch = (value) => {
			const text = cleanHTML(String(value ?? "")).trim();
			return text !== "" && !/missed punch/i.test(text);
		};

		// only days that carry both an in-punch and an out-punch belong in the list
		const punchedRecords = records.filter(
			(item) => hasPunch(item.punch_in) && hasPunch(item.punch_out)
		);

		let filteredItems = punchedRecords.filter((item) =>
    `${item.shift_date.toLowerCase()}`
        .includes(searchTerm.toLowerCase())
);

		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
		const indexOfLast = currentPage * entriesPerPage;
		const indexOfFirst = indexOfLast - entriesPerPage;
		// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

		const sortedItems = sortData(filteredItems);
const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);
	
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };


	  const clearInput = () => {
		setSearchTerm("");
	  };
	
	 





  useEffect(()=> {
	axios.get(API_BASE_URL +'/fetchshift', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	//.then(res =>console.log(res.data))
	 .then(res => setData(res.data))
	.catch(err => console.log(err));
},[])






const handleSubmit = async (e) => {
    e.preventDefault();
	setLoading(true);

	// alert(user.start_date);

    try {
      const response = await axios.post(API_BASE_URL +'/myshift',
		{ start_date: user.start_date, end_date: user.end_date, shift_id: user.shift_id }, 
		{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}

);
    //  console.log(response.data.calendar);
      setRecords(response.data.calendar); // Assuming the API response contains the records in `response.data`
	  setSummary(response.data.count || null);
	  setLoading(false);
	} catch (error) {
				  const res = error.response;
					setRecords([]); // Clear previous data on error
					setSummary(null);
				setLoading(false);
				if (!res) { toast.error('Network error'); return; }
				if (res.status === 422) {
				//   const errs = res.data?.errors || {};
				//   const firstMsg = Object.values(errs)[0]?.[0] || 'Validation failed';
				   toast.error(res.data.message, {
				position: 'bottom-right',
				autoClose: 5000,
				theme: 'colored',
				style: { backgroundColor: '#dc3545', color: '#fff' }
			  });
				} else {
				  toast.error(res.data?.message || `Error ${res.status}`);
				}
				} finally {
    setLoading(false);
  }
};

  useEffect(()=> {
	axios.post(API_BASE_URL +'/myshift',{ start_date: user.start_date, end_date: user.end_date, shift_id: user.shift_id }, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	//  .then(response =>console.log(response.data.calendar))
	 .then(response => {
		setRecords(response.data.calendar);
		setSummary(response.data.count || null);
	 })
	.catch(err => console.log(err));
},[])






const columns = [
  { label: "Emp Id", key: "employee_id", sortable: true },
  { label: "Employee Name", key: "emp_name", sortable: true },
  { label: "Shift Date", key: "shift_date", sortable: true },
  { label: "Punch In", key: "punch_in", sortable: false },
  { label: "Punch Out", key: "punch_out", sortable: false }
];


	return (
		<>
			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

						<ToastContainer/>
							

						</div>


						
					</div>


                    <div className="section-body mt-3">
					<div className="container-fluid">
						<div className="row clearfix">
							<div className="col-md-12">
								<div className="card">
									<div className="card-header d-flex justify-content-between align-items-center">
										<h3 className="card-title d-flex align-items-center" style={{ color: "#1d3a8a", fontWeight: 600 }}>
											<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
												<path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z"/>
												<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0"/>
											</svg>
											My Shift
										</h3>
									</div>
									<div className="card-body">
										 <form onSubmit={handleSubmit}> 

                                            <div class="row">

											<div className="col-md-2 col-sm-6">
												<div className="form-group">
												<label>Start Date</label>
												{/* <input type="date" className="form-control" name="start_date" value={user.start_date}
								onChange={handelInput} placeholder="Start Date" /> */}


												 <DatePicker
  selected={user.start_date ? new Date(user.start_date) : null}
  onChange={(date) => {
    const value = date
      ? date.toISOString().split("T")[0] // YYYY-MM-DD
      : "";

    setUser(prev => ({
      ...prev,
      start_date: value,
    }));
  }}
  dateFormat="dd-MM-yyyy"
  placeholderText="Select Start Date"
  className="form-control"
/>

											{/* {selectedDate && <p>Selected Date: {selectedDate.toDateString()}</p>} */}
												</div>
											</div>

											<div className="col-md-2 col-sm-6">
												<div className="form-group">
												<label>End Date</label>
												{/* <input type="date" className="form-control" name="end_date" value={user.end_date}
								onChange={handelInput} placeholder="End Date" /> */}
												<DatePicker
  selected={user.end_date ? new Date(user.end_date) : null}
  onChange={(date) => {
    const value = date
      ? date.toISOString().split("T")[0] // YYYY-MM-DD
      : "";

    setUser(prev => ({
      ...prev,
      end_date: value,
    }));
  }}
  dateFormat="dd-MM-yyyy"
  placeholderText="Select End Date"
  className="form-control"
/>
											{/* {selectedDate && <p>Selected Date: {selectedDate.toDateString()}</p>} */}
												</div>
											</div> 

                                            {/* <div className="col-md-2 col-sm-6">
									<div className="form-group">
										<input type="text" className="form-control" name="menu_icon" value={user.menu_icon}
								onChange={handelInput} placeholder="Menu Icon" />
									</div>
								</div> */}

                                

                                    {/* <div className="col-md-2 col-sm-6">
									<select name="shift_id" id="shift_id" className="form-control custom-select" value={user.shift_id} onChange={handelInput}>
										<option value="" disabled>Select Shiftcode</option>
											<option value="all">ALL</option>
											{data.map(option => (
											<option key={option.office_shift_id} value={option.office_shift_id}>
												{option.shift_name}
											</option>
											))}
										</select>
                                    </div> */}
                                    
							

								
								


                                <div className="col-md-4 col-sm-6">
									<div className="form-group">
									<label style={{visibility:'hidden', display:'block'}}>Action</label>

                                <button type="submit" className="btn btn-primary">
								GET
							</button>

							<Link to={`/attendancecalendar`} className="btn btn-primary" style={{marginLeft :"1rem"}}>Calendar View</Link>

							
                            </div>
                            </div>



							{/* <div className="col-md-2 col-sm-6">
									<div className="form-group">

                               

							<Link to={`/attendancecalendar`} className="btn btn-primary">Attendance Calendar</Link>

                            </div>
                            </div> */}


                            </div>

                            
                               

                                           


										
	
										
											
										 </form>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>




				{summary && (
					<div className="section-body mt-3">
						<div className="container-fluid">
							<div className="card">
								<div className="table-responsive">
									<table className="table table-striped table-vcenter text-nowrap mb-0 text-center">
										<thead>
											<tr>
												<th className="text-center">Total Days</th>
												<th className="text-center">Present Days</th>
												<th className="text-center">Paid Leaves</th>
												<th className="text-center">Holidays</th>
												<th className="text-center">Absent</th>
												<th className="text-center">LOP</th>
												<th className="text-center">Weekoff</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>{summary.total_days}</td>
												<td>{summary.present_days}</td>
												<td>{summary.paid_leaves}</td>
												<td>{summary.holidays}</td>
												<td>{summary.absent}</td>
												<td>{summary.lop}</td>
												<td>{summary.week_off}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				)}

					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">

										<div className="card-header">
											{/* record count, same "Showing x to y of z" line the other lists use */}
											<div className="text-muted" style={{ fontSize: "13px" }}>
												Showing {filteredItems.length === 0 ? 0 : indexOfFirst + 1} to{" "}
												{Math.min(indexOfLast, filteredItems.length)} of {filteredItems.length} entries
											</div>
											<div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>


										</div>


										{/* <div>
											<DataTable 
											columns={column} 
											data={data}
											customStyles={customStyles}
											pagination 
											highlightOnHover
											responsive
											paginationPerPage={10}
											paginationRowsPerPageOptions={[25,50,100,500]}
											className="table table-striped table-bordered"> 
										</DataTable>
										</div> */}







{/* Loading Spinner */}
{loading && (
											<div className="card-body">
											<div class="d-flex justify-content-center">
       <div class="spinner"></div>
	   </div>
	   </div>
      )}

{!loading && (
										<div className="card-body">
										
											<div className="table-responsive sticky-table-wrap" style={{ maxHeight: "420px" }}>




			<table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table">
													<thead>
														<tr>

															 {columns.map((col) => (
      <th
        key={col.key}
        onClick={col.sortable ? () => handleSort(col.key) : null}
        style={{ cursor: col.sortable ? "pointer" : "default" }}
      >
        {col.label}
         {col.sortable && (
      sortConfig.key === col.key
        ? (sortConfig.direction === "asc" ? " ▲" : " ▼")
        : " ⇅"   // <-- DEFAULT SORT ICON
    )}
		  </th>
    ))}
															
														</tr>
													</thead>
													<tbody>
													{filteredData.length > 0 ? (
															filteredData.map((record) => (
															<tr key={record.shift_date}>
																<td>{record.employee_id}</td>
																<td>{record.emp_name}</td>
																<td>{record.shift_date}</td>
																<td>{ReactHtmlParser(record.punch_in)}</td>
																<td>{ReactHtmlParser(record.punch_out)}</td>
															</tr>
															))
														) : (
															<tr>
															<td colSpan="5" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
															</tr>
														)}

											
													</tbody>
												</table>
											</div>
										
			 <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
								

										</div> 
)
}
									</div>
								</div>
	
							
							</div>
						</div>
					</div>

				</div>
			</div> 

										
			


			
			


			

		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(MyshiftControl);